import * as ACTION_CONSTS from '../constants/actions.constants';

export const initialState = many => ({
  loadingQueue: [],
  data: many ? [] : {},
});

const generic = (entityName, many = true, idField = 'id', fallbackReducer, append) => (state = initialState(many), action) => {
  if (!action.meta || (action.meta && !action.meta.entities.includes(entityName))) {
    return state;
  }
  // loading (Boolean) is now loadingQueue (array). The change reason is a boolean,
  // gets overridden upon receiving a data, is not suitable for certain states object - e.g.
  // Calls made for dashboard requires multiple calls for updating the visualisationData object.
  // Making the loading state boolean will result canceling out the spinner when data is still
  // loading into the object.
  switch (action.type) {
    case ACTION_CONSTS.REQUEST: {
      return {
        ...state,
        loadingQueue: [...state.loadingQueue, true],
      };
    }
    case ACTION_CONSTS.FINISH_LOAD_DATA: {
      return {
        ...state,
        loadingQueue: [...state.loadingQueue],
      };
    }
    case ACTION_CONSTS.RECEIVE_DATA:
      return {
        loadingQueue: [...state.loadingQueue.slice(1)],
        data: append
          ? { ...state.data, ...action.payload[entityName] }
          : action.payload[entityName],
      };
    case ACTION_CONSTS.UPDATE_DATA_SUCCESS: {
      return {
        ...state,
        loadingQueue: [...state.loadingQueue.slice(1)],
        data: many
          ? state.data.map(r => r[idField] === action.payload[entityName][idField]
            ? action.payload[entityName]
            : r)
          : action.payload,
      };
    }
    case ACTION_CONSTS.ADD_DATA_SUCCESS: {
      let applyData = action.payload;

      if (many) {
        applyData = [
          ...state.data,
          action.payload[entityName],
        ];
      }

      if (append) {
        const payload = action.payload[entityName];
        // Check for empty string that cannot be used with spread operator, which
        // this would crash IE11.
        if (typeof payload === 'string') applyData = { ...state.data };
        else applyData = { ...state.data, ...payload };
      }

      return {
        ...state,
        loadingQueue: [...state.loadingQueue.slice(1)],
        data: applyData,
      };
    }
    case ACTION_CONSTS.DELETE_DATA_SUCCESS: {
      return {
        ...state,
        loadingQueue: [...state.loadingQueue],
        data: many
          ? state.data.filter(o => o[idField] !== action.payload[entityName][idField])
          : {},
      };
    }
    case ACTION_CONSTS.REQUEST_FAILURE: {
      return {
        ...state,
        loadingQueue: [...state.loadingQueue.slice(1)],
      };
    }
    default:
      return fallbackReducer ? fallbackReducer(state, action) : state;
  }
};

export default generic;
